import { cn } from '@commenda/utils';
import React from 'react';

import { GlobalFilterTool } from '../../DataTable/internal/GlobalFilterTool';
import { Icons } from '../../Icons';
import {
  DATA_GRID_DEFAULT_FILTERS_LABEL,
  DATA_GRID_DEFAULT_GROUP_LABEL,
  DATA_GRID_DEFAULT_SETTINGS_LABEL,
  DATA_GRID_DEFAULT_SORT_LABEL,
} from '../constants';
import { DataGridToolbarConfig } from '../types';
import { DataGridToolbarActionButton } from './DataGridToolbarActionButton';
import { DataGridToolbarSearch } from './DataGridToolbarSearch';

export interface DataGridToolbarProps {
  config: DataGridToolbarConfig;
  className?: string;
}

const DataGridToolbar = ({ config, className }: DataGridToolbarProps) => (
  <div className={cn('flex h-12 items-center justify-between gap-lg', className)}>
    <div className="flex items-center gap-lg">
      {config.renderStart?.()}
      {config.filterConfig ? (
        <GlobalFilterTool filterConfig={config.filterConfig} />
      ) : config.filters?.isEnabled ? (
        <DataGridToolbarActionButton
          action={config.filters}
          icon={<Icons.FilterLines className="size-4" />}
          label={config.filters.label ?? DATA_GRID_DEFAULT_FILTERS_LABEL}
          isLabelVisible
        />
      ) : null}
    </div>

    <div className="flex items-center gap-lg">
      {config.sort?.isEnabled ? (
        <DataGridToolbarActionButton
          action={config.sort}
          icon={<Icons.SwitchVertical01 className="size-4" />}
          label={config.sort.label ?? DATA_GRID_DEFAULT_SORT_LABEL}
        />
      ) : null}
      {config.group?.isEnabled ? (
        <DataGridToolbarActionButton
          action={config.group}
          icon={<Icons.Grid01 className="size-4" />}
          label={config.group.label ?? DATA_GRID_DEFAULT_GROUP_LABEL}
        />
      ) : null}
      {config.settings?.isEnabled ? (
        <DataGridToolbarActionButton
          action={config.settings}
          icon={<Icons.Sliders04 className="size-4" />}
          label={config.settings.label ?? DATA_GRID_DEFAULT_SETTINGS_LABEL}
        />
      ) : null}
      {config.search?.isEnabled ? (
        <DataGridToolbarSearch config={config.search} />
      ) : null}
      {config.renderEnd?.()}
    </div>
  </div>
);

export { DataGridToolbar };
